import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Persist unhandled window errors & promise rejections so field-testing teams
// can retrieve them after a "blank / black screen" incident by visiting
// localStorage.getItem("bt.lastError") in DevTools.
function persistError(source, err) {
  try {
    const payload = {
      source,
      message: String(err?.message || err),
      stack: String(err?.stack || ""),
      href: window.location.href,
      ua: navigator.userAgent,
      at: new Date().toISOString(),
    };
    localStorage.setItem("bt.lastError", JSON.stringify(payload));
  } catch (_) {}
  // eslint-disable-next-line no-console
  console.error(`[${source}]`, err);
}

window.addEventListener("error", (e) => persistError("window.error", e.error || e.message));
window.addEventListener("unhandledrejection", (e) => persistError("unhandledrejection", e.reason));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
